function cov_1v2i1ojwhw() {
  var path = "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/Expertise.tsx";
  var hash = "e262b2be0d51bf509035642b57161f60d2f41d7a";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/Expertise.tsx",
    statementMap: {
      "0": {
        start: {
          line: 1,
          column: 49
        },
        end: {
          line: 4,
          column: 1
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "e262b2be0d51bf509035642b57161f60d2f41d7a"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_1v2i1ojwhw = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_1v2i1ojwhw();
var Icon = (cov_1v2i1ojwhw().s[0]++, {
  name: 'expertise',
  svg: "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M12.8187 1.33913C12.3666 0.886957 11.6334 0.886957 11.1813 1.33913L10.0269 2.49354L8.50837 1.89391C7.9136 1.65904 7.24104 1.9508 7.00617 2.54557L6.45454 3.94248H4.81515C4.17569 3.94248 3.65729 4.46087 3.65729 5.10034V6.77092L2.38496 7.32286C1.79832 7.57735 1.52905 8.25923 1.78354 8.84588L2.35566 10.1647L1.33913 11.1813C0.886957 11.6334 0.886957 12.3666 1.33913 12.8187L2.49353 13.9731L1.89389 15.4916C1.65902 16.0864 1.95078 16.7589 2.54555 16.9938L3.65729 17.4328V18.7543C3.65729 19.3938 4.17569 19.9122 4.81516 19.9122H6.58414L7.32285 21.615C7.57734 22.2017 8.25921 22.471 8.84586 22.2165L10.1647 21.6443L11.1813 22.6609C11.6334 23.113 12.3666 23.113 12.8187 22.6609L13.9731 21.5065L15.4916 22.1061C16.0864 22.341 16.7589 22.0492 16.9938 21.4544L17.6028 19.9122H19.0395C19.6789 19.9122 20.1973 19.3938 20.1973 18.7543V17.2922L21.615 16.6772C22.2017 16.4227 22.4709 15.7408 22.2164 15.1541L21.6443 13.8353L22.6609 12.8187C23.113 12.3666 23.113 11.6334 22.6609 11.1813L21.5065 10.0269L22.1061 8.5084C22.3409 7.91362 22.0492 7.24106 21.4544 7.00619L20.1973 6.50978V5.10034C20.1973 4.46087 19.6789 3.94248 19.0395 3.94248H17.3528L16.6771 2.38498C16.4227 1.79834 15.7408 1.52907 15.1541 1.78356L13.8353 2.35568L12.8187 1.33913ZM13.9409 9.57692L17.4233 10.078C17.7741 10.1289 17.9139 10.5564 17.6572 10.8027L15.1388 13.24L15.7349 16.6822C15.7948 17.0276 15.4269 17.2937 15.1131 17.1295L11.9986 15.5046L8.88415 17.1295C8.57042 17.2937 8.2025 17.0304 8.26239 16.6822L8.85849 13.24L6.34008 10.8027C6.08625 10.5564 6.226 10.1289 6.57681 10.078L10.0592 9.57692L11.6165 6.44604C11.7733 6.13182 12.2268 6.13182 12.3837 6.44604L13.9409 9.57692Z\" fill=\"currentColor\"/>"
});
export default Icon;